$(document).ready(function() {
  $("#zipCode").on('keydown',function(e) {
    if(e.which == 13) {
        if ($(this).val()) {
          $("#applyButton").click();
        }
        event.preventDefault();
        return false;
    }
  });
})




/* Fancybox Slider */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Fancybox for product gallery
  if (typeof jQuery.fancybox === 'function') {
    jQuery('#main-product-images .product-image-gallery').fancybox({
      loop: true,          // allows cycling through images
      arrows: true,        // show prev/next arrows
      buttons: [
        "zoom",
        "close"
      ],
      touch: false,        // disable built-in touch because we'll handle global swipe
      backFocus: false     // prevent focus issues
    });
  }

  // Mobile swipe support
  if (window.innerWidth <= 1024) {
    let startX = 0;
    let threshold = 50; // Minimum swipe distance in px

    function handleTouchStart(e) {
      if (!e.touches || e.touches.length === 0) return;
      startX = e.touches[0].clientX;
    }

    function handleTouchEnd(e) {
      if (!e.changedTouches || e.changedTouches.length === 0) return;
      let endX = e.changedTouches[0].clientX;
      let diff = endX - startX;

      if (Math.abs(diff) < threshold) return;

      // Only trigger if Fancybox is open
      let fancyboxOpen = document.querySelector('.fancybox-wrap.fancybox-opened');
      if (!fancyboxOpen) return;

      if (diff > 0) {
        // Swipe right → previous image
        let prevBtn = fancyboxOpen.querySelector('.fancybox-prev');
        if (prevBtn) prevBtn.click();
      } else {
        // Swipe left → next image
        let nextBtn = fancyboxOpen.querySelector('.fancybox-next');
        if (nextBtn) nextBtn.click();
      }
    }

    // Attach touch events to the document (global swipe)
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
  }
});






(function($) {
  $(window).on('load', function() {

    var $main = $('#main-product-images');
    var $prev = $main.find('a.previous');
    var $next = $main.find('a.next');

    var mainSlider = $main.data('flexslider');
    if (!mainSlider) return;

    function updateArrowState(slider) {
      var index = slider.currentSlide;
      var lastIndex = slider.count - 1;

      // Previous arrow
      if (index === 0) {
        $prev.addClass('disabled');
      } else {
        $prev.removeClass('disabled');
      }

      // Next arrow
      if (index === lastIndex) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    }

    // Initial state
    updateArrowState(mainSlider);

    // After every slide change
    var originalAfter = mainSlider.vars.after;
    mainSlider.vars.after = function(slider) {
      updateArrowState(slider);
      if (typeof originalAfter === 'function') {
        originalAfter(slider);
      }
    };

  });
})(jQuery);




/* Thumbnail slider on the default Product template */

(function($) {
  $(window).on('load', function() {

    var $main = $('#main-product-images');
    var $thumbs = $('#product-thumbnails-wrapper');
    var $track = $thumbs.find('ul.slides');
    var $items = $thumbs.find('li');
    var mainSlider = $main.data('flexslider');
    if (!mainSlider) return;

    // Disable loop
    mainSlider.vars.animationLoop = false;

    // Make thumbnail track flex
    $track.css({ display: 'flex', cursor: 'default', width: 'auto' });

    var totalThumbs = $items.length;

    function getVisibleCount() {
      var thumbWidth = $items.outerWidth(true);
      return Math.floor($thumbs.width() / thumbWidth);
    }

    function scrollThumbs(activeIndex) {
      var thumbWidth = $items.outerWidth(true);
      var visibleCount = getVisibleCount();
      var maxFirstVisible = Math.max(totalThumbs - visibleCount, 0);

      // Compute firstVisible dynamically
      var firstVisible = activeIndex - Math.floor(visibleCount / 2);
      if (firstVisible < 0) firstVisible = 0;
      if (firstVisible > maxFirstVisible) firstVisible = maxFirstVisible;

      // Compute target scroll
      var targetScroll = firstVisible * thumbWidth;

      // Clamp scroll
      var maxScroll = totalThumbs * thumbWidth - $thumbs.width();
      if (targetScroll > maxScroll) targetScroll = maxScroll;
      if (targetScroll < 0) targetScroll = 0;

      // Apply scroll
      $track.css({
        transform: 'translate3d(' + (-targetScroll) + 'px,0,0)',
        transition: 'transform 0.25s ease'
      });

      // Update active class
      $items.removeClass('flex-active-slide').eq(activeIndex).addClass('flex-active-slide');
    }

    // MAIN → THUMB SYNC
    var originalBefore = mainSlider.vars.before;
    mainSlider.vars.before = function(slider) {
      scrollThumbs(slider.animatingTo);
      if (typeof originalBefore === 'function') originalBefore(slider);
    };

    // THUMB → MAIN SYNC
    $items.on('click', function() {
      var index = $(this).index();
      mainSlider.flexAnimate(index, true, false, function() {
        scrollThumbs(index);
      });
    });

    // INITIAL SYNC
    scrollThumbs(mainSlider.currentSlide);

    // On resize
    $(window).on('resize', function() {
      scrollThumbs(mainSlider.currentSlide);
    });

  });
})(jQuery);



// (function($) {
//   $(window).on('load', function() {

//     function waitRubikSwipers(callback, interval = 100, timeout = 1000) {
//       const start = Date.now();
//       const check = () => {
//         const mainEl = document.querySelector('.rubik-swiper .main-swiper');
//         const thumbEl = document.querySelector('.rubik-swiper .thumb-swiper');
//         if (mainEl && thumbEl && mainEl.swiper && thumbEl.swiper) {
//           callback(mainEl.swiper, thumbEl.swiper);
//         } else if (Date.now() - start < timeout) {
//           setTimeout(check, interval);
//         }
//       };
//       check();
//     }

//     waitRubikSwipers(function(mainSwiper, thumbSwiper) {

//       /* -----------------------------
//          MAIN + THUMB SYNC (unchanged)
//       ----------------------------- */

//       mainSwiper.params.loop = false;
//       thumbSwiper.params.loop = false;
//       thumbSwiper.params.freeMode = true;
//       thumbSwiper.update();

//       const getVisibleCount = () => window.innerWidth > 992 ? 6 : 4;

//       const updateThumbPosition = (activeIndex) => {
//         const visibleCount = getVisibleCount();
//         const totalThumbs = thumbSwiper.slides.length;
//         const thumbWidth = thumbSwiper.slides[0].offsetWidth +
//           parseInt(getComputedStyle(thumbSwiper.slides[0]).marginRight);

//         let firstVisible = activeIndex - Math.floor(visibleCount / 2);
//         firstVisible = Math.max(0, Math.min(firstVisible, totalThumbs - visibleCount));

//         if (window.innerWidth > 992) {
//           thumbSwiper.setTranslate(-firstVisible * thumbWidth);
//           thumbSwiper.slides.forEach(s => s.classList.remove('swiper-slide-thumb-active'));
//           thumbSwiper.slides[activeIndex]?.classList.add('swiper-slide-thumb-active');
//           thumbSwiper.el.style.display = 'flex';
//         } else {
//           thumbSwiper.el.style.display = 'none';
//         }

//         if (window.innerWidth <= 992 && !mainSwiper.pagination.el) {
//           mainSwiper.params.pagination = {
//             el: '.rubik-swiper .swiper-pagination',
//             clickable: true
//           };
//           mainSwiper.pagination.init();
//           mainSwiper.pagination.render();
//           mainSwiper.pagination.update();
//         }
//       };

//       mainSwiper.on('slideChange', () => updateThumbPosition(mainSwiper.activeIndex));
//       thumbSwiper.slides.forEach((s, i) => s.addEventListener('click', () => mainSwiper.slideTo(i)));
//       updateThumbPosition(mainSwiper.activeIndex || 0);
//       window.addEventListener('resize', () => updateThumbPosition(mainSwiper.activeIndex));

//       /* -----------------------------
//          ZOOM MODAL SWIPER (FIXED)
//       ----------------------------- */

//       $('.rubik-swiper .main-swiper .swiper-slide img').on('click', function() {

//         const currentIndex = $(this).closest('.swiper-slide').index();

//         // Remove legacy zoom + previous modal
//         $('.zoom-modal, .rubik-zoom-modal').remove();

//         // Lock scroll
//         $('body').css('overflow', 'hidden');

//         let modalHtml = `
//           <div class="rubik-zoom-modal" style="
//             position:fixed;
//             inset:0;
//             background:rgba(0,0,0,0.9);
//             z-index:9999;
//             display:flex;
//             justify-content:center;
//             align-items:center;
//           ">
//             <div class="rubik-zoom-slider swiper-container">
//               <div class="swiper-wrapper">`;

//         $('.rubik-swiper .main-swiper .swiper-slide img').each(function() {
//           modalHtml += `
//             <div class="swiper-slide" style="
//               max-width:600px;
//               width:90%;
//               display:flex;
//               justify-content:center;
//             ">
//               <img src="${$(this).attr('src')}" style="
//                 width:100%;
//                 height:auto;
//                 display:block;
//               ">
//             </div>`;
//         });

//         modalHtml += `
//               </div>
//               <div class="swiper-button-prev"></div>
//               <div class="swiper-button-next"></div>
//               <div class="swiper-pagination"></div>
//             </div>
//           </div>`;

//         $('body').append(modalHtml);

//         const zoomSwiper = new Swiper('.rubik-zoom-slider', {
//           initialSlide: currentIndex,
//           centeredSlides: true,
//           slidesPerView: 'auto',
//           spaceBetween: 30,
//           loop: false,
//           navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev'
//           },
//           pagination: {
//             el: '.swiper-pagination',
//             clickable: true
//           }
//         });

//         /* Close ONLY when clicking outside the slide */
//         $('.rubik-zoom-modal').on('click', function(e) {
//           if ($(e.target).closest(
//             '.swiper-slide, .swiper-button-next, .swiper-button-prev, .swiper-pagination'
//           ).length === 0) {
//             zoomSwiper.destroy(true, true);
//             $(this).remove();
//             $('body').css('overflow', 'auto');
//           }
//         });
//       });

//     });

//   });
// })(jQuery);



(function($) {
  $(window).on('load', function() {

    function waitRubikSwipers(callback, interval = 100, timeout = 2000) {
      const start = Date.now();
      const check = () => {
        const mainEl = document.querySelector('.rubik-swiper .main-swiper');
        const thumbEl = document.querySelector('.rubik-swiper .thumb-swiper');
        if (mainEl && thumbEl && mainEl.swiper && thumbEl.swiper) {
          callback(mainEl.swiper, thumbEl.swiper);
        } else if (Date.now() - start < timeout) {
          setTimeout(check, interval);
        }
      };
      check();
    }

    waitRubikSwipers(function(mainSwiper, thumbSwiper) {

      /* -----------------------------
         MAIN + THUMB SYNC
      ----------------------------- */

      mainSwiper.params.loop = false;
      thumbSwiper.params.loop = false;
      thumbSwiper.params.freeMode = true;
      thumbSwiper.update();

      const getVisibleCount = () => window.innerWidth > 992 ? 6 : 4;

      const updateThumbPosition = (activeIndex) => {
        const visibleCount = getVisibleCount();
        const totalThumbs = thumbSwiper.slides.length;

        if (!totalThumbs) return;

        const thumbWidth = thumbSwiper.slides[0].offsetWidth +
          parseInt(getComputedStyle(thumbSwiper.slides[0]).marginRight);

        let firstVisible = activeIndex - Math.floor(visibleCount / 2);
        firstVisible = Math.max(0, Math.min(firstVisible, totalThumbs - visibleCount));

        if (window.innerWidth > 992) {
          thumbSwiper.setTranslate(-firstVisible * thumbWidth);
          thumbSwiper.slides.forEach(s => s.classList.remove('swiper-slide-thumb-active'));
          thumbSwiper.slides[activeIndex]?.classList.add('swiper-slide-thumb-active');
          thumbSwiper.el.style.display = 'flex';
        } else {
          thumbSwiper.el.style.display = 'none';
        }

        if (window.innerWidth <= 992 && !mainSwiper.pagination.el) {
          mainSwiper.params.pagination = {
            el: '.rubik-swiper .swiper-pagination',
            clickable: true
          };
          mainSwiper.pagination.init();
          mainSwiper.pagination.render();
          mainSwiper.pagination.update();
        }
      };

      mainSwiper.on('slideChange', () => {
        updateThumbPosition(mainSwiper.activeIndex);
      });

      thumbSwiper.slides.forEach((s, i) =>
        s.addEventListener('click', () => mainSwiper.slideTo(i))
      );

      updateThumbPosition(mainSwiper.activeIndex || 0);
      window.addEventListener('resize', () =>
        updateThumbPosition(mainSwiper.activeIndex)
      );

    });

    /* -----------------------------
       ZOOM MODAL (DELEGATED)
       Works after variant change
    ----------------------------- */

    $(document).on('click', '.rubik-swiper .main-swiper .swiper-slide img', function() {

      const $slides = $('.rubik-swiper .main-swiper .swiper-slide');
      const currentIndex = $(this).closest('.swiper-slide').index();

      // Remove old modals
      $('.zoom-modal, .rubik-zoom-modal').remove();

      // Lock scroll
      $('body').css('overflow', 'hidden');

      let modalHtml = `
        <div class="rubik-zoom-modal" style="
          position:fixed;
          inset:0;
          background:rgba(0,0,0,0.9);
          z-index:9999;
          display:flex;
          justify-content:center;
          align-items:center;
        ">
          <div class="rubik-zoom-slider swiper-container">
            <div class="swiper-wrapper">`;

      $slides.each(function() {
        const img = $(this).find('img');
        modalHtml += `
          <div class="swiper-slide" style="
            max-width:600px;
            width:90%;
            display:flex;
            justify-content:center;
          ">
            <img src="${img.attr('src')}" style="
              width:100%;
              height:auto;
              display:block;
            ">
          </div>`;
      });

      modalHtml += `
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>`;

      $('body').append(modalHtml);

      const zoomSwiper = new Swiper('.rubik-zoom-slider', {
        initialSlide: currentIndex,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: '.rubik-zoom-modal .swiper-button-next',
          prevEl: '.rubik-zoom-modal .swiper-button-prev'
        },
        pagination: {
          el: '.rubik-zoom-modal .swiper-pagination',
          clickable: true
        }
      });

      // Close only outside slide
      $('.rubik-zoom-modal').on('click', function(e) {
        if ($(e.target).closest(
          '.swiper-slide, .swiper-button-next, .swiper-button-prev, .swiper-pagination'
        ).length === 0) {
          zoomSwiper.destroy(true, true);
          $(this).remove();
          $('body').css('overflow', 'auto');
        }
      });

    });

  });
})(jQuery);





/* Prevent the content moving when popup */

(function($) {
  $(document).ready(function() {

    // Listen for clicks on the main product image links
    $(document).on('click', '[data-fancybox="product-gallery"]', function() {
      // Immediately add classes to <html>
      document.documentElement.classList.add('fancybox-margin', 'fancybox-lock');

      // Wait for Fancybox to fully initialize
      if (typeof $.fancybox !== 'undefined') {
        $.fancybox.getInstance(); // ensures instance exists

        // Listen for Fancybox close event to remove classes
        $(document).one('afterClose.fb', function() {
          document.documentElement.classList.remove('fancybox-margin', 'fancybox-lock');
        });
      }
    });

  });
})(jQuery);